import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { BillSummaryRow } from "@/components/bills/BillParts";
import { api } from "@/lib/api";
import { money } from "@/lib/format";

const Stat = ({ label, value, tone = "", testId }) => (
  <div className="rounded-xl bg-secondary/60 px-3 py-2.5 min-w-0">
    <div className="text-[11px] text-muted-foreground">{label}</div>
    <div className={`font-num font-semibold text-base sm:text-lg truncate ${tone}`} data-testid={testId}>{money(value)}</div>
  </div>
);

export function OutstandingPanel() {
  const [d, setD] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { api.get("/bills/outstanding").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <section className="surface overflow-hidden mb-6 fade-up border-l-4 border-l-primary" data-testid="outstanding-balances">
      <div className="px-4 sm:px-5 pt-4 pb-3 flex flex-wrap items-center justify-between gap-2">
        <h2 className="font-heading text-lg font-semibold">Outstanding Balances</h2>
        <button onClick={() => navigate("/bills")} className="text-sm font-semibold text-sky-700 hover:underline" data-testid="outstanding-view-bills">View bills →</button>
      </div>
      {d.bills.length === 0 ? (
        <div className="px-5 pb-5 flex items-center gap-2 text-sm text-emerald-800" data-testid="outstanding-all-paid"><CheckCircle2 className="h-5 w-5 text-emerald-600" />All bills are paid up</div>
      ) : (<>
        <div className="px-4 sm:px-5 grid grid-cols-2 lg:grid-cols-5 gap-2">
          <Stat label="Total outstanding" value={d.total_outstanding_cents} testId="outstanding-total" />
          <Stat label="Overdue" value={d.total_overdue_cents} tone="text-rose-600" testId="outstanding-overdue" />
          <Stat label="Due in next 7 days" value={d.due_next_7_days_cents} tone="text-amber-700" testId="outstanding-due-soon" />
          <Stat label="Utilities" value={d.utilities_cents} testId="outstanding-utilities" />
          <Stat label="Vendor Purchases" value={d.vendor_purchases_cents} testId="outstanding-vendor-purchases" />
        </div>
        <div className="mt-3 divide-y divide-border border-t border-border" data-testid="outstanding-list">
          {d.bills.map((b) => <BillSummaryRow key={b.id} b={b} onOpen={(x) => navigate(`/bills?bill=${x.id}`)} />)}
        </div>
      </>)}
    </section>
  );
}
